import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { useId as i } from "react";
const d = "_section_1bo23_1", h = "_heading_1bo23_7", m = "_list_1bo23_16", _ = "_card_1bo23_25", p = "_cardTop_1bo23_36", u = "_cardHeading_1bo23_43", f = "_text_1bo23_51", g = "_meta_1bo23_58", v = "_stars_1bo23_64", C = "_star_1bo23_64", s = {
  section: d,
  heading: h,
  list: m,
  card: _,
  cardTop: p,
  cardHeading: u,
  text: f,
  meta: g,
  stars: v,
  star: C
}, x = (t) => {
  const e = Math.max(0, Math.min(5, t)), r = Math.round(e * 2) / 2, o = Math.floor(r), c = r % 1 !== 0;
  return Array.from({ length: 5 }, (M, l) => l < o ? "full" : l === o && c ? "half" : "empty");
}, b = ({ fill: t }) => {
  const e = i(), r = t === "full" ? "var(--reviews-star-color-full)" : t === "half" ? `url(#${e})` : "var(--reviews-star-color-empty)";
  return /* @__PURE__ */ n("svg", { "aria-hidden": "true", className: s.star, "data-fill": t, height: 19, viewBox: "0 0 20 19", width: 20, children: [
    t === "half" && /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ n("linearGradient", { id: e, x1: "0", x2: "1", y1: "0", y2: "0", children: [
      /* @__PURE__ */ a("stop", { offset: "50%", stopColor: "var(--reviews-star-color-full)" }),
      /* @__PURE__ */ a("stop", { offset: "50%", stopColor: "var(--reviews-star-color-empty)" })
    ] }) }),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M9.07088 0.612343C9.41462 -0.204115 10.5854 -0.204114 10.9291 0.612346L12.9579 5.43123C13.1029 5.77543 13.4306 6.01061 13.8067 6.0404L19.0727 6.45748C19.9649 6.52814 20.3267 7.62813 19.6469 8.2034L15.6348 11.5987C15.3482 11.8412 15.223 12.2218 15.3106 12.5843L16.5363 17.661C16.744 18.5211 15.7969 19.201 15.033 18.7401L10.5245 16.0196C10.2025 15.8252 9.7975 15.8252 9.47548 16.0196L4.96699 18.7401C4.20311 19.201 3.25596 18.5211 3.46363 17.661L4.68942 12.5843C4.77698 12.2218 4.65182 11.8412 4.36526 11.5987L0.353062 8.2034C-0.326718 7.62813 0.0350679 6.52814 0.927291 6.45748L6.19336 6.0404C6.5695 6.01061 6.89716 5.77543 7.04207 5.43123L9.07088 0.612343Z",
        fill: r
      }
    )
  ] });
}, w = ({ value: t }) => {
  const e = x(t);
  return /* @__PURE__ */ a("span", { "aria-label": `Rated ${Math.max(0, Math.min(5, t))} out of 5 stars`, className: s.stars, role: "img", children: e.map((r, o) => /* @__PURE__ */ a(b, { fill: r }, o)) });
}, N = ({ review: t }) => {
  const e = [t.reviewerName, t.reviewDate].filter(Boolean).join(", ");
  return /* @__PURE__ */ n("li", { className: s.card, children: [
    /* @__PURE__ */ n("div", { className: s.cardTop, children: [
      t.reviewHeading && /* @__PURE__ */ a("h3", { className: s.cardHeading, children: t.reviewHeading }),
      /* @__PURE__ */ a(w, { value: t.reviewStarRating })
    ] }),
    /* @__PURE__ */ a("p", { className: s.text, children: t.reviewText }),
    e && /* @__PURE__ */ a("p", { className: s.meta, "data-testid": "review-meta", children: e })
  ] });
}, L = ({ heading: t, reviews: e }) => {
  const r = e ?? [];
  return /* @__PURE__ */ n("section", { className: s.section, children: [
    t && /* @__PURE__ */ a("h2", { className: s.heading, children: t }),
    r.length > 0 && /* @__PURE__ */ a("ul", { className: s.list, children: r.map((o, c) => /* @__PURE__ */ a(N, { review: o }, c)) })
  ] });
};
function R(t) {
  return /* @__PURE__ */ a(L, { ...t });
}
export {
  L as ReviewsSection,
  R as default
};
//# sourceMappingURL=index.es.js.map
